<!-- Invoice template starts -->
<div class="row">
  <div class="col-12">
    <div class="content-header">Invoice</div>
  </div>
</div>
<section class="invoice-template">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content p-3">
          <div id="invoice-template" class="card-body pb-0">
            <!-- Invoice Company Details starts -->
            <div id="invoice-company-details" class="row">
              <div class="col-md-6 col-12">
                <div class="media">
                  <img src="assets/img/logos/logo-color-big.png" alt="company logo" width="80" height="80">
                  <div class="media-body ml-4">
                    <ul class="m-0 list-unstyled">
                      <li class="text-bold-800">Pixinvent Creative Studio</li>
                      <li>4025 Oak Avenue, Melbourne,</li>
                      <li>Florida 32940, USA</li>
                    </ul>
                  </div>
                </div>

              </div>
              <div class="col-md-6 col-12 text-right">
                <h2 class="primary text-uppercase">Invoice</h2>
                <p class="pb-3"># INV-001001</p>
                <ul class="px-0 list-unstyled">
                  <li>Balance Due</li>
                  <li class="font-medium-2 text-bold-700">$12,000.00</li>
                </ul>
              </div>
            </div>
            <!-- Invoice Company Details ends -->
            <!-- Invoice Customer Details starts -->
            <div id="invoice-customer-details" class="row">
              <div class="col-12 text-left">
                <p class="text-muted mb-1">Bill To</p>
              </div>
              <div class="col-md-6 col-12">
                <ul class="m-0 list-unstyled">
                  <li class="text-bold-800">Mr. Bret Lezama</li>
                  <li>4879 Westfall Avenue,</li>
                  <li>Albuquerque,</li>
                  <li>New Mexico-87102.</li>
                </ul>
              </div>
              <div class="col-md-6 col-12 text-right">
                <p><span class="text-muted">Invoice Date :</span> 06/05/2016</p>
                <p><span class="text-muted">Terms :</span> Due on Receipt</p>
                <p class="m-0"><span class="text-muted">Due Date :</span> 10/05/2016</p>
              </div>
            </div>
            <!-- Invoice Customer Details ends -->
            <!-- Invoice Items Details starts -->
            <div id="invoice-items-details">
              <div class="row">
                <div class="table-responsive col-12">
                  <table class="table mt-3">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Item &amp; Description</th>
                        <th class="text-right">Rate</th>
                        <th class="text-right">Hours</th>
                        <th class="text-right">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">1</th>
                        <td>
                          <p>Create PSD for mobile APP</p>
                          <p class="text-muted">Simply dummy text of the printing and typesetting industry.</p>
                        </td>
                        <td class="text-right">$20.00/hr</td>
                        <td class="text-right">120</td>
                        <td class="text-right">$2400.00</td>
                      </tr>
                      <tr>
                        <th scope="row">2</th>
                        <td>
                          <p>iOS Application Development</p>
                          <p class="text-muted">Pellentesque maximus feugiat lorem at cursus.</p>
                        </td>
                        <td class="text-right">$25.00/hr</td>
                        <td class="text-right">260</td>
                        <td class="text-right">$6500.00</td>
                      </tr>
                      <tr>
                        <th scope="row">3</th>
                        <td>
                          <p>WordPress Template Development</p>
                          <p class="text-muted">Vestibulum euismod est eu elit convallis.</p>
                        </td>
                        <td class="text-right">$20.00/hr</td>
                        <td class="text-right">300</td>
                        <td class="text-right">$6000.00</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row mt-3 mt-md-0">
                <div class="col-md-6 col-12 text-left">
                  <p class="text-bold-700 mb-1 ml-1">Payment Methods:</p>
                  <div class="row">
                    <div class="col-12">
                      <table class="table table-borderless table-sm">
                        <tbody>
                          <tr>
                            <td>Bank name:</td>
                            <td class="text-right">ABC Bank, USA</td>
                          </tr>
                          <tr>
                            <td>Acc name:</td>
                            <td class="text-right">Amanda Orton</td>
                          </tr>
                          <tr>
                            <td>IBAN:</td>
                            <td class="text-right">FGS165461646546AA</td>
                          </tr>
                          <tr>
                            <td>SWIFT code:</td>
                            <td class="text-right">BTNPP34</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <p class="text-bold-700 mb-2 ml-4">Total due</p>
                  <div class="table-responsive">
                    <table class="table">
                      <tbody>
                        <tr>
                          <td>Sub Total</td>
                          <td class="text-right">$14,900.00</td>
                        </tr>
                        <tr>
                          <td>TAX (12%)</td>
                          <td class="text-right">$1,788.00</td>
                        </tr>
                        <tr>
                          <td class="text-bold-800">Total</td>
                          <td class="text-bold-800 text-right"> $16,688.00</td>
                        </tr>
                        <tr>
                          <td>Payment Made</td>
                          <td class="danger text-right">(-) $4,688.00</td>
                        </tr>
                        <tr class="text-bold-500">
                          <td>Balance Due</td>
                          <td class="text-right">$12,000.00</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Invoice Items Details ends -->
            <!-- Invoice Footer starts -->
            <div id="invoice-footer">
              <div class="row mt-2 mt-sm-0">
                <div class="col-md-6 col-12 d-flex align-items-center">
                  <div class="terms-conditions mb-2">
                    <h6>Terms & Condition</h6>
                    <p>You know, being a test pilot isn't always the healthiest business in the world. We predict too much for the next year and yet far too little for the next 10.</p>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="signature text-center">
                    <p>Authorized person</p>
                    <img src="assets/img/pages/signature-scan.png" alt="signature" width="250">
                    <h6 class="mt-4">Amanda Orton</h6>
                    <p class="text-muted">Managing Director</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center text-sm-right">
                  <button type="button" class="btn btn-primary btn-print mt-2 mt-md-1"><i class="ft-printer mr-1"></i>Print Invoice</button>
                </div>
              </div>
            </div>
            <!-- Invoice Footer ends -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Invoice template ends -->
